<template>
  <div class="black-bg" v-if="shown" @click="close" v-portal>
    
        <div class="close" ref="clo"></div>
        <img :src="src" alt="" class="bg-img" ref="src" :style="{'margin-top':gogo}">

  </div>
</template>

<script>
export default {
    data(){
        return{
            shown:false,
            ops:{bar:{
                opacity:0,
            }},
            gogo:'100px',
        }
    },
    props:{
        src:{
            default:'',
            type:String,
        },
        show:{
            default:false,
            type:Boolean
        }
    },
    methods:{
        close(e){
            if(this.$refs.src.contains(e.target)) return;
            this.shown=false
            this.$emit('change',false)
        }
    },
    directives: {
    portal: {
      //自定义指令用于外层渲染
      inserted: function (el, binding) {
        var value = binding.value;
        console.log(binding);
        var app = document.querySelector("#app");
        try {
          if (value) {
            typeof value == "string"
              ? document.querySelector(value).appendChild(el)
              : value.appendChild(el);
          } else app.appendChild(el);
        } catch (error) {
          console.log(error);
        }
      },
      unbind: function (el) {
        try {
          el.parentNode.removeChild(el);
        } catch (error) {
          console.log(error);
        }
      },
    },
  },
    watch:{
        show: {
            handler: function (newdata) {
               this.shown=newdata
               this.$nextTick(()=>{
                  console.log(window.scrollY)
                  this.gogo=window.scrollY+100+'px'
                   console.log(!!this.$refs.src,!!this.$refs.clo)
                   if(!!this.$refs.src&&!!this.$refs.clo){
                       var src=this.$refs.src.getBoundingClientRect(),clo=this.$refs.clo;
                    console.log(src.left+src.width)
                       clo.style.left=src.left+src.width+'px'
                       clo.style.top=window.scrollY+60+'px'
                   }
               })
            },
            // deep: true,
            // immediate: true,
        },
    }
}
</script>

<style scoped>
.black-bg{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table-cell;
    text-align: center;
    z-index: 999999;
    /* overflow: auto; */
}
.bg-img{
    margin: 0 auto;
    /* margin-top:100px ; */
}
.close{
    cursor: pointer;
    width: 39px;
    height: 39px;
    position: absolute;
    top: 60px;
    z-index: 999999;
    background: url('../../../assets/img/guanb.png');
}
</style>